<span class="col-2 order-text margin-full-menu-order-title" >{{ 'ORDER_BY' | translate }}</span>
<mat-select id="drpOrder" (selectionChange)="sortMenuBy($event.value)" [value]="selectedSort" class="select">
  <mat-option  *ngFor="let option of 'itemsOrder' | translate" [value]="option.value">
    {{option.text}}
  </mat-option>